import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppTokenHandler } from '../common/app-token-handler';
import { TRDtls } from '../model/tracking-request-detail';
import { Router } from '@angular/router';
import { AlertService } from './alert.service';

@Injectable({ providedIn: 'root' })
export class DataService {
    private apiUrl: string;
    private secretKey: string = environment.appcode;
    token: any;
    constructor(private appToken: AppTokenHandler, private http: HttpClient,private route: Router,
        private alertService: AlertService
    ) {
        this.apiUrl = environment.serviceBaseUrl;
    }
    ngOnInit() {
        //debugger;
        // this.GetUserDetails('/INFTE/home');
    //     if (this.appToken.getAzureTokenFromLocalStorage() == '') {
    //         var account = this.msalService.instance.getAllAccounts()[0];
    //         const accessTokenRequest = {
    //           scopes: ["user.read"],
    //           account: account,
    //         };

    //         this.msalService.acquireTokenPopup(accessTokenRequest).subscribe((res) => {
    //             this.token = res.accessToken;
    //             this.appToken.setAzureTokenLocalStorage(this.token);
    //             //this.GetUserDetails();
    //         },
    //         (error: Response) => {

    //           if (error.status <= 0) {
    //             this.route.navigate(['/error/2']);
    //           } else if (error.status === 401) {
    //             this.route.navigate(['/error/1']);
    //           } else {
    //             this.route.navigate(['/error/2']);
    //           }
    //         })
    //     }
    //     else {
    //       this.GetUserDetails();
    //     }
    }
    GetUserDetails() {
        if (this.appToken.getSessionToken().length <= 0) {
            this.Login().subscribe((data: any) => {
                this.appToken.setSessionToken(data);
                this.route.navigate(['/home']);
            },
                (error: Response) => {
                    if (error.status <= 0) {
                        this.route.navigate(['/badrequest']);
                    }
                    else if (error.status == 401) {
                        this.route.navigate(['/unauthorize']);
                    }
                    else {
                        this.alertService.notify('error', 'Server Error', error.statusText);
                    }
                });
        }
        else {
            this.route.navigate(['/home']);
        }
    };
    // Login() {
    //     const tokenPath: string = environment.tokenPath  ;
    //     return this.http
    //       .post(tokenPath, { withCredentials: true })
    //       .pipe(
    //         map((response: any) => response),
    //         catchError((error) => {
    //           return throwError(() => error.message);
    //         })
    //       );
    //     // const httpLoginPostOptions = {
    //     //     withCredentials: true
    //     // };
    //     // return this.http.post(environment.tokenPath, httpLoginPostOptions).pipe(catchError(this.handleError));
    // }

    Login(Email: string = '', AzureToken: string = '') {
        const body: any = null;
        // const httpDataServiceOptions = {
        //     headers: new HttpHeaders({ AzureAccessToken: AzureToken }), withCredentials: true
        // }
        return this.http.post(environment.tokenPath, {withCredentials: true}).pipe(catchError(this.handleError));
    }
    LoginWithEmail(Email: string) {
        const body: any = null;
        let params = new HttpParams();
        params = params.append('Email', Email);
        const httpLoginPostOptions = {
            withCredentials: true,
            params: params
        };
        return this.http.post(environment.tokenPath, JSON.stringify(body), httpLoginPostOptions).pipe(catchError(this.handleError));
    }

    refreshToken() {
        const httpLoginPostOptions = {
            withCredentials: true
        };
        return this.http.post(environment.tokenPath, null, httpLoginPostOptions).pipe(catchError(this.handleError));
    }
    GetEmployeeByName(_url: string, empname: string) {
        empname = empname.replace(/ /g, '-');
        _url = environment.serviceBaseUrl + _url + empname;
        return this.http.get<any>(_url, { withCredentials: true });
    }
    GetData(_url: string) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    GetDataById(_url: string, _id: string) {
        _url = environment.serviceBaseUrl + _url + "/" + _id;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    PostData(_url: string, _postdata: any) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.post(_url, _postdata, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    PostDataForAnalytic(_url: string, _postdata: any) {
        return this.http.post(_url, _postdata, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    DeleteData(_url: string, _deletedata: any) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.post(_url, _deletedata, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    PostDataWithFile(_url: string, _postdata: any) {
        const httpFileUploadOptions =
        {
            headers: { 'enctype': 'multipart/form-data' },
            withCredentials: true
        }
        _url = environment.serviceBaseUrl + _url;
        return this.http.post(_url, _postdata, httpFileUploadOptions).pipe(catchError(this.handleError));
    }
    LogPageAnalytics(url) {
        return this.http.jsonp(url, "JSONP_CALLBACK").pipe();
    }
    ContainsSpecialCharacters(searchString: string) {
        let IsValidString: boolean = true;
        if (searchString.length > 0) {
            let regex = /^[A-Za-z0-9 ]+$/;
            IsValidString = regex.test(searchString);
        }
        return (IsValidString == true ? false : true);
    }
    ContainsSpecialCharactersWithRegEx(searchString: string, regex: RegExp) {
        let IsValidString: boolean = true;
        if (searchString.length > 0) {
            IsValidString = regex.test(searchString);
        }
        return (IsValidString == true ? false : true);
    }
    EncryptData(data: string): string {
        return data;
    }
    DecryptData(data: string): string {
        return data;
    }
    private handleError(error: Response) {
        return throwError(error);
    }
    // Added code by dhirendra for CR_2502_0025
    UpdateData(_url: string,_postdata: any) {
    _url = environment.serviceBaseUrl + _url;
    return this.http.post(_url,_postdata, { withCredentials: true }).pipe(catchError(this.handleError));
    }   
// End code by dhirendra for CR_2502_0025
}

@Injectable()
export class UIBlockingStatus {
    private IsBlocked: BehaviorSubject<boolean>;
    constructor() {
        this.IsBlocked = new BehaviorSubject(false);
    }

    setStatus(_IsBlocked: boolean) {
        this.IsBlocked.next(_IsBlocked);
    }

    getStatus(): Observable<boolean> {
        return this.IsBlocked.asObservable();
    }

}